import styled from 'react-emotion';
import BaseButton from '../BaseButton/BaseButton';

export const RadiusButtonWrapper = styled(BaseButton)`
  border-radius: 5px;
`;
